import commonUtil from '../../utils/commonUtil';
import serverClientUtil from '../../utils/serverClientUtil';

const KALTURA_START_SESSION = '/service/session/action/start';        

export function getKalturaSessionOLD() {
  return commonUtil.triggerServerRequest({ url: '/api/kaltura/kalturaCreateSession', method: 'POST' });
}

// https://www.kaltura.com/api_v3/service/session/action/start?format=1&type=0&secret=9b3be578a11222f7b50d184900524e7d&partnerId=2374251&userId=sdolla%40zensar.com&expiry=86400',\n     headers: \n      { cookie: [Array],\n        host: 'grdev.liverpool.com.mx:3000',\n        correlationId: 42880 },\n     method: 'GET' } } '\\n\\nService-Facade ::: Hitting Servive API Service: URL::' 'https://www.kaltura.com/api_v3/service/session/action/start?format=1&type=0&secret=9b3be578a11222f7b50d184900524e7d&partnerId=2374251&userId=sdolla%40zensar.com&expiry=86400'","timestamp":"2018-03-20T12:28:10.469Z"}

export function getKalturaSession() {
  let kalturaURL = serverClientUtil.getKalturaURL() + KALTURA_START_SESSION + '?format=1&type=0';
  const KalturaUser = '&userId=' + serverClientUtil.getKalturaUser();
  const KalturaSecretKey = '&secret=' + serverClientUtil.getKalturaSecretKey();
  const KalturaPartnerID = '&partnerId=' + serverClientUtil.getKalturaPartnerID();
  kalturaURL = kalturaURL + KalturaUser + KalturaSecretKey + KalturaPartnerID;

  return commonUtil.triggerServerRequest({ url: kalturaURL, method: 'GET' });
} 
export function getKalturaStartSession() {    
  return commonUtil.triggerServerRequest({ url: '/api/kaltura/kalturaStartSession', method: 'POST' });
}